import { Box, Typography, Rating } from '@mui/material';
import { useState } from 'react';
import { isAndroid } from 'react-device-detect';

import CloseIcon from 'components/common/icons/Close';
import useTranslates from 'utils/translate';
import useSettings, { IWebsiteConfigs } from 'store/settings';
import useMount from 'hooks/useMount';
import useApkState from 'hooks/useApkState';

const HEIGHT = 80;
const ANIMATION_DURATION = 300;
const ANIMATION_START_TIME = 3000;

const pixelate = (value: number) => `${value}px`;

const ApplicationDialog = ({ forceHide }: { forceHide: boolean }) => {
  const [margin, setMargin] = useState<number>(-HEIGHT);
  const { translate } = useTranslates();
  const [
    {
      data: { favicon, meta = {} as IWebsiteConfigs },
    },
  ] = useSettings();

  const [isApkVisible, ,hideApkFor24Hours] = useApkState(true);

  useMount(() => {
    const timerId = setTimeout(() => {
      setMargin(0);
      clearTimeout(timerId);
    }, ANIMATION_START_TIME);
  });

  if (!isAndroid) return null;
  if (!isApkVisible) return null;
  if (!meta.androidAppUrl) return null;
  if (forceHide) return null;

  const onClick = () => {
    setMargin(-HEIGHT);
    const timerId = setTimeout(() => {
      hideApkFor24Hours();
      clearTimeout(timerId);
    }, ANIMATION_DURATION);
  };

  return (
    <Box
      display="flex"
      flexDirection="row"
      padding="16px 24px"
      justifyContent="space-between"
      bgcolor="text.primary"
      style={{
        transition: `margin-top ${ANIMATION_DURATION}ms`,
      }}
      height={pixelate(HEIGHT)}
      marginTop={pixelate(margin)}
    >
      <Box display="flex" gap="16px">
        <CloseIcon
          color="secondary"
          style={{ width: 12, height: 12, display: 'flex', alignSelf: 'center' }}
          onClick={onClick}
        />
        <Box display="flex" gap="8px">
          <img width={48} height={48} rel="icon" src={meta?.androidAppIcon || favicon} />
          <Box>
            <Typography color="background.default" display="flex" alignItems="center">
              {meta?.androidAppName || 'Application'}
            </Typography>
            <Rating defaultValue={4.5} precision={0.5} size="small" readOnly />
          </Box>
        </Box>
      </Box>
      <Typography fontWeight={600} color="background.default" display="flex" alignItems="center">
        <a href={meta.androidAppUrl} download={window.location.host}>
          {translate('download')}
        </a>
      </Typography>
    </Box>
  );
};

export default ApplicationDialog;
